var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:("mdi mdi-" + _vm.icon),attrs:{"fill":"currentColor","width":"24","height":"24"}},[_c('path',{attrs:{"d":_vm.pathData}})])}
var staticRenderFns = []

export { render, staticRenderFns }